// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.wrapper .map_section {
  width: 75%;
  height: 100%;
  transition: ease-in-out 1s;
}
.wrapper .map_section.full-width {
  width: 100%;
}
@media (max-width: 992px) {
  .wrapper .map_section {
    width: 100%;
  }
}
.wrapper .map_section.hide_section {
  width: 0%;
}
.wrapper .sidebar_section {
  padding-top: 11vw;
  width: 25%;
  box-shadow: -4.141304493px 0px 56.9429397583px 0px rgba(0, 0, 0, 0.1019607843);
  background: url('background.png') no-repeat center center/120% 120%;
  background-size: cover;
  transition: width 1.5s flex-direction 2s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  transition: ease-in-out 1s;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section {
    width: 0;
  }
  .wrapper .sidebar_section app-venue-suggestion {
    visibility: none;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
}
.wrapper .sidebar_section.full-width {
  padding: 100px 50px;
  transition: all 1s;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}
.wrapper .sidebar_section.full-width .title {
  display: none;
  visibility: none;
  opacity: 0;
  transition: visibility 2s;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width {
    flex-direction: column !important;
    width: 100% !important;
    padding: 150px 5px 10px;
    flex-wrap: nowrap;
  }
}
.wrapper .sidebar_section.full-width app-venue-suggestion {
  width: 24%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width app-venue-suggestion {
    width: 100%;
    opacity: 1;
    margin: 0 0 5px 0;
  }
}

#map {
  width: 100%;
  height: 100%;
  z-index: 0;
}
#map img {
  max-height: none !important;
  max-width: none !important;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
  width: 100%;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 15px;
}

#search-container {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.search-container-input {
  top: 30px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 100%;
}
@media (max-width: 992px) {
  app-venue-suggestion {
    width: 90%;
    margin: 0 auto;
  }
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
}

.mode-icon {
  padding: 10px;
  height: 25px;
  width: 25px;
}

.mode-icon {
  fill: #808080;
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  fill: #f8f8f8;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}
.loading-container ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  color: white;
}
@media (min-width: 991px) {
  .loading-container ion-spinner {
    width: 80px;
    height: 80px;
  }
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-venues {
  background: #f8f8f8;
}

.full-height {
  height: 100%;
}

#show_toggler,
#search-container-input {
  position: absolute;
  top: 11vw !important;
  left: 40%;
  border: 1px solid var(--ion-color-primary);
  transform: translateX(-50%);
  width: 60vw;
  display: flex;
  flex-direction: column;
  height: 90px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
  padding: 10px;
  transition: top 1s;
  z-index: 10;
}
#show_toggler.full-width,
#search-container-input.full-width {
  left: 50%;
}
@media (max-width: 992px) {
  #show_toggler,
  #search-container-input {
    width: 360px;
    height: 70px;
    padding: 2px;
    left: 50%;
    top: 12vw !important;
  }
}
#show_toggler h3,
#search-container-input h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
}
#show_toggler.move_up,
#search-container-input.move_up {
  top: 10px !important;
}
@media (max-width: 992px) {
  #show_toggler.move_up,
  #search-container-input.move_up {
    top: 70px !important;
  }
}
#show_toggler.show_no_venue_found,
#search-container-input.show_no_venue_found {
  flex-direction: column;
  height: auto;
  min-height: 120px;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: 14px;
}
#show_toggler.show_no_venue_found p,
#search-container-input.show_no_venue_found p {
  margin-top: 10px;
  padding-left: 50px;
  padding-right: 14px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
}
@media (max-width: 992px) {
  #show_toggler.show_no_venue_found p,
  #search-container-input.show_no_venue_found p {
    font-size: 12px;
  }
}

swiper-slide {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

app-map-search-venue {
  width: 100%;
}

#show_toggler h3 {
  text-transform: uppercase;
  font-size: 16px;
}

.scroll-block {
  max-height: calc(100vh - 95px);
  --background: transparent;
  background: transparent;
  --padding-start: 20px;
  --padding-end: 20px;
}

.search-restaurant {
  width: 100%;
  margin-left: 10px;
  color: var(--ion-color-primary);
}
@media (max-width: 992px) {
  .search-restaurant {
    margin-left: 0px;
  }
}
.search-restaurant ion-input {
  font-family: AppFontBold, sans-serif;
  font-size: 24px;
  color: #808080;
}
@media (max-width: 992px) {
  .search-restaurant ion-input {
    font-size: 16px;
  }
}

.seach-icon-large {
  zoom: 1.4;
}

.mode-icon {
  cursor: pointer;
}

.slide-item {
  position: relative;
  padding: 0px 15px 0px;
  width: 100%;
  min-height: 120px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.slide-item .back_icon {
  position: absolute;
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 100%;
}
.slide-item .forward_icon {
  position: absolute;
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.mobile-view-toggle {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: bottom 0.3s ease-in-out;
}
.mobile-view-toggle.has-bottom-card {
  bottom: 155px;
}
.mobile-view-toggle.venue-expanded {
  bottom: 255px;
}
.mobile-view-toggle ion-button {
  --box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  font-weight: bold;
  min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/maps/components/map-venue/map-venue.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;AADD;AAEC;EACC,UAAA;EAIA,YAAA;EACA,0BAAA;AAHF;AADE;EACC,WAAA;AAGH;ACLE;EDDD;IAQE,WAAA;EAED;AACF;AADE;EACC,SAAA;AAGH;AAAC;EASC,iBAAA;EACA,UAAA;EACA,8EAAA;EACA,mEAAA;EACA,sBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAPF;AC5BE;EDaD;IAEE,QAAA;EAiBD;EAhBC;IACC,gBAAA;IACA,UAAA;IACA,kCAAA;EAkBF;AACF;AADE;EAOC,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAHH;AAVG;EACC,aAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AAYJ;ACtDE;EDqCA;IAgBE,iCAAA;IACA,sBAAA;IACA,uBAAA;IACA,iBAAA;EAKF;AACF;AAJG;EACC,UAAA;AAMJ;ACjEE;ED0DC;IAGE,WAAA;IAEA,UAAA;IACA,iBAAA;EAOH;AACF;;AADA;EACC,WAAA;EACA,YAAA;EACA,UAAA;AAID;AAFC;EACC,2BAAA;EACA,0BAAA;AAIF;;AAAA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AAGD;;AAAA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAGD;;AADA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAID;;AAFA;EACC,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAKD;AAHC;EACC,WAAA;AAKF;;AAFA;EACC,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAKD;;AAHA;EACC,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAMD;;AAHA;EACC,oBAAA;AAMD;;AAHA;EACC,WAAA;AAMD;AC3IE;EDoIF;IAGE,UAAA;IACA,cAAA;EAQA;AACF;;AANA;EACC,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AASD;;AAPA;EACC,YAAA;AAUD;;AAPA;EACC,aAAA;EACA,YAAA;EACA,WAAA;AAUD;;AAPA;EACC,aAAA;EACA,uBAAA;AAUD;;AAPA;EACC,oCAAA;EACA,aAAA;EACA,uBAAA;AAUD;;AAPA;EACC,YAAA;AAUD;;AAPA;EAKC,cAAA;EACA,YAAA;AAMD;AAXC;EACC,gBAAA;AAaF;AAPC;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AASF;;AANA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AASD;AARC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAUF;ACxNE;EDuMD;IASE,WAAA;IACA,YAAA;EAYD;AACF;;AARA;EACC,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAWD;AATC;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAWF;AARC;EACC,eAAA;AAUF;AAPC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AASF;;AALA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAQD;;AALA;EACC,mBAAA;AAQD;;AANA;EACC,YAAA;AASD;;AAPA;;EAEC,kBAAA;EACA,oBAAA;EAEA,SAAA;EAIA,0CAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,wDAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAMD;AArBC;;EACC,SAAA;AAwBF;ACnRE;EDoPF;;IAuBE,YAAA;IACA,YAAA;IACA,YAAA;IACA,SAAA;IACA,oBAAA;EAaA;AACF;AAXC;;EACC,oCAAA;EACA,eAAA;AAcF;AAZC;;EACC,oBAAA;AAeF;ACtSE;EDsRD;;IAGE,oBAAA;EAkBD;AACF;AAfC;;EACC,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA;AAkBF;AAjBE;;EAIC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAiBH;AC9TE;EDoSA;;IAEE,eAAA;EA6BF;AACF;;AAnBA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AAsBD;;AApBA;EACC,WAAA;AAuBD;;AApBC;EACC,yBAAA;EACA,eAAA;AAuBF;;AApBA;EACC,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAuBD;;AAlBA;EACC,WAAA;EACA,iBAAA;EAaA,+BAAA;AASD;ACjWE;EDyUF;IAIE,gBAAA;EAwBA;AACF;AAvBC;EACC,oCAAA;EACA,eAAA;EACA,cAAA;AAyBF;AC3WE;ED+UD;IAKE,eAAA;EA2BD;AACF;;AAtBA;EACC,SAAA;AAyBD;;AAvBA;EACC,eAAA;AA0BD;;AAxBA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA2BD;AAzBC;EACC,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,+BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA2BF;AAzBC;EACC,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA2BF;;AAvBA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mCAAA;AA0BD;AAxBC;EACC,aAAA;AA0BF;AAvBC;EACC,aAAA;AAyBF;AAtBC;EACC,0CAAA;EACA,iBAAA;EACA,gBAAA;AAwBF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\t.map_section {\n\t\twidth: 75%;\n\t\t&.full-width {\n\t\t\twidth: 100%;\n\t\t}\n\t\theight: 100%;\n\t\ttransition: ease-in-out 1s;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t\t&.hide_section {\n\t\t\twidth: 0%;\n\t\t}\n\t}\n\t.sidebar_section {\n\t\t@include mobile {\n\t\t\twidth: 0;\n\t\t\tapp-venue-suggestion {\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: opacity 1s ease-in-out;\n\t\t\t}\n\t\t}\n\t\tpadding-top: 11vw;\n\t\twidth: 25%;\n\t\tbox-shadow: -4.1413044929504395px 0px 56.94293975830078px 0px #0000001a;\n\t\tbackground: url('../../../assets/background/background.png') no-repeat center center / 120% 120%;\n\t\tbackground-size: cover;\n\t\ttransition: width 1.5s flex-direction 2s;\n\t\toverflow: auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\ttransition: ease-in-out 1s;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\theight: 100%;\n\n\t\t&.full-width {\n\t\t\t.title {\n\t\t\t\tdisplay: none;\n\t\t\t\tvisibility: none;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: visibility 2s;\n\t\t\t}\n\t\t\tpadding: 100px 50px;\n\t\t\ttransition: all 1s;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: row;\n\t\t\t@include mobile {\n\t\t\t\tflex-direction: column !important;\n\t\t\t\twidth: 100% !important;\n\t\t\t\tpadding: 150px 5px 10px;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t\tapp-venue-suggestion {\n\t\t\t\twidth: 24%;\n\t\t\t\t@include mobile {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n#map {\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 0;\n\n\timg {\n\t\tmax-height: none !important;\n\t\tmax-width: none !important;\n\t}\n}\n\n.search-bar {\n\tborder-radius: 4px;\n\tline-height: 1.6;\n\twidth: 100%;\n}\n\n.search-bar > div {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tplace-items: center;\n}\n.title {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tmargin-left: 15px;\n\tmargin-top: 15px;\n}\n#search-container {\n\ttop: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n\n\tapp-venue-suggestion {\n\t\twidth: 100%;\n\t}\n}\n.search-container-input {\n\ttop: 30px;\n\tleft: 0px;\n\tright: 0px;\n\tposition: absolute;\n\tpadding: 0px;\n\tbackground: white;\n}\n.slides-container {\n\tposition: absolute;\n\tbottom: 20px;\n\tleft: 0;\n\tright: 0;\n}\n\n.swiper-slide {\n\talign-self: flex-end;\n}\n\napp-venue-suggestion {\n\twidth: 100%;\n\t@include mobile {\n\t\twidth: 90%;\n\t\tmargin: 0 auto;\n\t}\n}\n.map-toggle {\n\tdisplay: flex;\n\tjustify-content: space-between !important;\n\talign-items: center;\n\tpadding: 5px;\n}\n.map-toggle-container {\n\theight: 48px;\n}\n\n.mode-icon {\n\tpadding: 10px;\n\theight: 25px;\n\twidth: 25px;\n}\n\n.mode-icon {\n\tfill: #808080;\n\ttransition: 0.3s linear;\n}\n\n.mode-icon.selected {\n\tbackground: var(--ion-color-primary);\n\tfill: #f8f8f8;\n\ttransition: 0.3s linear;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.sidebar {\n\tapp-venue-suggestion {\n\t\tmargin: 5px auto;\n\t}\n\n\toverflow: auto;\n\theight: 100%;\n\n\t.title {\n\t\twidth: 90%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n}\n.loading-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\tbackground: black;\n\topacity: 0.5;\n\tion-spinner {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 70px;\n\t\theight: 70px;\n\t\tcolor: white;\n\t\t@include desktop {\n\t\t\twidth: 80px;\n\t\t\theight: 80px;\n\t\t}\n\t}\n}\n\n.hint {\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tpadding: 14px;\n\tbackground: white;\n\n\tp {\n\t\tfont-size: 12px;\n\t\tcolor: black;\n\t\tmargin: 0;\n\t\tpadding: 0 8px;\n\t}\n\n\tspan {\n\t\tfont-size: 14px;\n\t}\n\n\tion-icon {\n\t\theight: 44px;\n\t\twidth: 44px;\n\t\tplace-self: center;\n\t}\n}\n\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.block-venues {\n\tbackground: #f8f8f8;\n}\n.full-height {\n\theight: 100%;\n}\n#show_toggler,\n#search-container-input {\n\tposition: absolute;\n\ttop: 11vw !important;\n\n\tleft: 40%;\n\t&.full-width {\n\t\tleft: 50%;\n\t}\n\tborder: 1px solid var(--ion-color-primary);\n\ttransform: translateX(-50%);\n\twidth: 60vw;\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 90px;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbox-shadow: 0px 0px 50px 0px #0000001a;\n\tbackground: white;\n\tpadding: 10px;\n\ttransition: top 1s;\n\tz-index: 10;\n\t@include mobile {\n\t\twidth: 360px;\n\t\theight: 70px;\n\t\tpadding: 2px;\n\t\tleft: 50%;\n\t\ttop: 12vw !important;\n\t}\n\n\th3 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 20px;\n\t}\n\t&.move_up {\n\t\ttop: 10px !important;\n\t\t@include mobile {\n\t\t\ttop: 70px !important;\n\t\t}\n\t}\n\n\t&.show_no_venue_found {\n\t\tflex-direction: column;\n\t\theight: auto;\n\t\tmin-height: 120px;\n\t\tjustify-content: flex-start;\n\t\talign-items: flex-start;\n\t\tpadding-bottom: 14px;\n\t\tp {\n\t\t\t@include mobile {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t\tmargin-top: 10px;\n\t\t\tpadding-left: 50px;\n\t\t\tpadding-right: 14px;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n}\nswiper-slide {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: auto;\n}\napp-map-search-venue {\n\twidth: 100%;\n}\n#show_toggler {\n\th3 {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 16px;\n\t}\n}\n.scroll-block {\n\tmax-height: calc(100vh - 95px);\n\t--background: transparent;\n\tbackground: transparent;\n\t--padding-start: 20px;\n\t--padding-end: 20px;\n\t// app-venue-suggestion {\n\t//   width: 100% !important;\n\t// }\n}\n.search-restaurant {\n\twidth: 100%;\n\tmargin-left: 10px;\n\t@include mobile {\n\t\tmargin-left: 0px;\n\t}\n\tion-input {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 24px;\n\t\tcolor: #808080;\n\t\t@include mobile {\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n\n\tcolor: var(--ion-color-primary);\n}\n.seach-icon-large {\n\tzoom: 1.4;\n}\n.mode-icon {\n\tcursor: pointer;\n}\n.slide-item {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\twidth: 100%;\n\tmin-height: 120px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-direction: row;\n\n\t.back_icon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 5px;\n\t\tcolor: var(--ion-color-primary);\n\t\tfill: var(--ion-color-primary);\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tbackground-color: white;\n\t\tborder-radius: 100%;\n\t}\n\t.forward_icon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tright: 5px;\n\t\tcolor: var(--ion-color-primary);\n\t\tfill: var(--ion-color-primary);\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 100%;\n\t}\n}\n\n.mobile-view-toggle {\n\tposition: absolute;\n\tbottom: 20px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tz-index: 1000;\n\ttransition: bottom 0.3s ease-in-out;\n\n\t&.has-bottom-card {\n\t\tbottom: 155px;\n\t}\n\n\t&.venue-expanded {\n\t\tbottom: 255px;\n\t}\n\n\tion-button {\n\t\t--box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\t\tfont-weight: bold;\n\t\tmin-width: 100px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
